module.exports = __webpack_public_path__ + "img/company-sub-company.40433b73.png";